import { Toaster, toast } from "sonner";
import { scrollToId } from "@/lib/scroll";

const links = [
  { label: "Para profissionais", href: "#dores", testId: "nav-link-profissionais" },
  { label: "Funcionalidades", href: "#modulos", testId: "nav-link-modulos" },
  { label: "Como funciona", href: "#metodo", testId: "nav-link-metodo" },
  { label: "Histórias", href: "#depoimentos", testId: "nav-link-historias" },
  { label: "Planos", href: "#oferta", testId: "nav-link-planos" },
];

export default function Nav() {
  return (
    <>
      <Toaster position="top-center" richColors />
      <header className="sticky top-0 z-50 border-b border-black/10 bg-white/95 backdrop-blur-xl">
        <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-6 sm:px-10">
          <button
            data-testid="nav-logo"
            onClick={() => scrollToId("#topo")}
            className="font-dmsans text-xl font-bold tracking-[0.08em] text-black"
          >
            MOM
          </button>

          <nav className="hidden items-center gap-7 lg:flex">
            {links.map((l) => (
              <button
                key={l.href}
                data-testid={l.testId}
                onClick={() => scrollToId(l.href)}
                className="font-dmsans text-[12px] font-medium uppercase tracking-[0.12em] text-black/60 transition-colors duration-300 hover:text-black"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-6">
            <button
              data-testid="nav-entrar"
              onClick={() => toast("A área do assinante MOM abre em breve.")}
              className="hidden font-dmsans text-[12px] font-medium uppercase tracking-[0.12em] text-black/60 transition-colors hover:text-black sm:block"
            >
              Entrar
            </button>
            <button
              data-testid="nav-cta"
              onClick={() => scrollToId("#oferta")}
              className="rounded-full bg-gradient-to-r from-mom-vinho to-mom-carmim px-5 py-2.5 font-dmsans text-[12px] font-semibold text-white transition-[filter] duration-300 hover:brightness-110"
            >
              Começar agora
            </button>
          </div>
        </div>
      </header>
    </>
  );
}
